import * as React from "react";
import {
  Grid,
  TextField,
  MenuItem,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  Box,
  Checkbox,
  FormGroup,
  Switch,
} from "@mui/material";
import { snakeCaseToTitleCase } from "../utils/CaseFormatHelper";
import DateBasedForm from "./DateBasedForm";
import StandardRecurrenceForm from "./StandardRecurrenceForm";

export type ActionRecurrence = {
  start_on_program_start: boolean;
  start_after_program_start: boolean;
  start_after_program_start_value: number;
  start_after_program_start_unit: string;
  repeat: boolean;
  repeat_value: number;
  repeat_unit: string;
  monday: boolean;
  tuesday: boolean;
  wednesday: boolean;
  thursday: boolean;
  friday: boolean;
  saturday: boolean;
  sunday: boolean;
  end_timing: string;
  occurences: number;
  end_date_value: number;
  end_after_program_start_value: number;
  end_after_program_start_unit: string;
  action_id?: number;
  start_month: number;
  start_day: number;
  end_month: number;
  end_day: number;
  recurrence_type: string;
};

interface Props {
  readOnly: boolean;
  // setHasUnsavedChanges: any;
  recurrence?: ActionRecurrence;
  onDataChange: Function;
}

const FormPanel: React.FC<Props> = (props: any) => {
  React.useEffect(() => {
  }, [])

  const handleBooleanChange = (event: any) => {
    props.onDataChange({
      ...props.recurrence,
      [event.target.name]: isTrue(event.target.value),
    });
  };

  const handleStringChange = (event: any) => {
    props.onDataChange({
      ...props.recurrence,
      [event.target.name]: event.target.value,
    });
  };

  const handleDayChange = (event: any) => {
    props.onDataChange({
      ...props.recurrence,
      [event.target.name]: event.target.checked,
    });
  };

  const isTrue = (value) => {
    return value === "true";
  };

  return (
    <Grid
      container
      className="form-container form-panel-container"
      style={{
        margin: "5px 0 0 0",
        padding: "10px 20px 0 20px",
      }}
    >
      <Grid
        item
        xs={12}
        style={{
          color: "#000000",
          fontWeight: 800,
          fontSize: "1.2em",
        }}
      >
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <div>Action Recurrence</div>
          <div style={{ display: 'flex', justifyContent: 'start', alignItems: 'center', gap: '10px', fontSize: '14px', fontWeight: 'normal', marginTop: '-5px'}}>
            <div> Standard Action </div>
            <Switch
              checked={props.recurrence?.recurrence_type === "date_based"}
              disabled={props.readOnly}
              onChange={(_, checked) => { 
                props.onDataChange({
                  ...props.recurrence,
                  recurrence_type: checked ? "date_based" : "standard",
                });
                // setRecurrenceType(checked ? "date_based" : "standard")
              }}
              sx={{
                '& .MuiSwitch-track': {
                  backgroundColor: 'gray',
                },
                '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                  backgroundColor: 'gray',
                },
                '& .MuiSwitch-thumb': {
                  backgroundColor: '#ff890a',
                },
                '& .Mui-checked .MuiSwitch-thumb': {
                  backgroundColor: '#ff890a',
                },
              }}
            />
            <div> Date-Based Action</div>
          </div>
        </div>
      </Grid>
      {
        props.recurrence?.recurrence_type == "date_based" ?
          <DateBasedForm readOnly={props.readOnly} recurrence={props.recurrence} handleBooleanChange={handleBooleanChange} handleStringChange={handleStringChange} handleDayChange={handleDayChange}/>
          :
          <StandardRecurrenceForm readOnly={props.readOnly} recurrence={props.recurrence} handleBooleanChange={handleBooleanChange} handleStringChange={handleStringChange} handleDayChange={handleDayChange}/>
          
      }
    </Grid>
  );
};

export default FormPanel;
